<template>
    <div class="container">
        <div class="searchBox">
            <!-- <div class="left">
                <el-form :inline="true">
                    <el-form-item label="客户总数"> ：共{{customerTotal}} 位
                    </el-form-item>
                    <el-form-item>
                        <el-input placeholder="手机号/公司名称" v-model="formObj.fuzzyQuery" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button icon="el-icon-search" type="primary" @click="fuzzySearchClick">查询</el-button>
                    </el-form-item>
                </el-form>
            </div> -->
            <div class="right">
                <!-- <el-form :inline="true">
                    <el-form-item>
                        <el-select placeholder="全部身份" v-model="formObj.userType" @change="multiSearchClick">
                            <el-option label="全部身份" value=""></el-option>
                            <el-option :label="list.text" :value="list.value" :key="index" v-for="(list,index) in userTypeOptions"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-select placeholder="全部审核状态" v-model="formObj.authResult" @change="multiSearchClick">
                            <el-option label="全部审核状态" value=""></el-option>
                            <el-option :label="list.text" :value="list.value" :key="index"  v-for="(list,index) in authResultOptions"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form> -->
                <el-button type="primary" @click="toAdd">新增园区+</el-button>
                <!-- <el-button type="primary">下载园区列表</el-button> -->
            </div>
        </div>
        <div class="tableBox">
            <el-table v-loading="isLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)" ref="multipleTable" border stripe :data="tableData"
                tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
            <!--    <el-table-column type="selection" width="55">
                </el-table-column> -->
             <!--   <el-table-column label="" width="70">
                    <template slot-scope="scope">{{ total-((searchObj.page-1)*searchObj.num+ scope.$index) }}</template>
                </el-table-column> -->
                <el-table-column label="园区ID" width="70">
                    <template slot-scope="scope">{{ scope.row.park_id }}</template>
                </el-table-column>
                <el-table-column label="园区姓名">
                    <template slot-scope="scope">{{ scope.row.park_name }}</template>
                </el-table-column>
                <el-table-column label="园区排序">
                    <template slot-scope="scope">{{ scope.row.park_map_sequence }}</template>
                </el-table-column>

                <el-table-column label="园区地址">
                    <template slot-scope="scope">{{ scope.row.address }}</template>
                </el-table-column>
                <el-table-column label="联系人">
                    <template slot-scope="scope">{{ scope.row.park_contact_name }}</template>
                </el-table-column>
                <el-table-column label="联系电话" >
                    <template slot-scope="scope">{{ scope.row.park_contact_cellphone }}</template>
                </el-table-column>
                <el-table-column label="园区标签" >
                    <template slot-scope="scope">
                        <!-- <span :class="{green:scope.row.user_type==1,blue:scope.row.user_type==2}">{{ scope.row.user_type | turnValToText("user_type")}}</span> -->
                        <!-- <span>{{ scope.row.store_tag}}</span> -->
                        <!-- <span>{{scope.row.store_tag}}</span> -->
                        <span>{{scope.row.store_tag_name}}</span>
                        <!-- <tagSelect :value="scope.row.store_tag" :type="'park'" :showArea="'name'"></tagSelect> -->
                    </template>
                </el-table-column>
                <el-table-column label="园区概要" width="190">
                    <template slot-scope="scope">
                      {{scope.row.park_intro}}
                      <!-- <div class="infiveline" >

                      </div> -->
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="250">
                    <template slot-scope="scope">
                        <div style="text-align: left;">
                            <el-button type="primary" size="mini" @click="toDetail(scope.row.park_id)">查看</el-button>
                            <el-button type="primary" size="mini" @click="toEdit(scope.row.park_id)">编辑</el-button>
                            <el-switch @change=changeIsShow(scope.row.park_id)
                              v-model="scope.row.isShow"
                             >
                            </el-switch>
                            <span v-if="scope.row.isShow" style="color:#409EFF">已展示</span>
                            <span v-if="!scope.row.isShow" style="color:#bbb">已隐藏</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pageBox">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="searchObj.page"
                :page-size.sync="searchObj.num" layout="total, sizes, prev, pager, next, jumper" :total="total"
                background>
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import {
        json,
        wordData
    } from '@/common/common.js'
    import {
        ajaxPost
    } from '@/common/request.js'
    import {
        utils
    } from '@/common/common.js'
    export default {
        name: 'adminIndex',
        data() {
            return {
              tag_list_park:[],
                lastPage:'',
                newLinkParamObj:{},
                isShowAddOrderModal:false,
                isLoading: false,
                msg: 'Welcome to Your Vue.js App',
                formObj: {
                    fuzzyQuery: '',
                    userType: '',
                    authResult: '',
                },
                searchObj: {
                    page: 1,
                    num: 10,
                },
                //表格
                tableData: [],
                multipleSelection: [],
                //分页
                total: 0,
                isShowModal: false,

            }
        },
        computed: {
            adminId() {
                let oUserInfo=utils.getItem('userInfo')?JSON.parse(utils.getItem('userInfo')) :{}
                console.log(oUserInfo.adminId,'computed里的adminId')
                return oUserInfo.adminId
            },

        },
        components: {
        },
        methods: {
          getTagName(val){
            //val='1,2'
            let result=[]
            let arr=val?val.split(","):[]
            this.tag_list_park.forEach(function(item,index){
              if(arr.indexOf(item.tag_id)>=0){
                result.push(item.tag_name)
              }
            })
            return result.join(",")

          },
          get_tag_list_park(){
            let _this=this
            // alert(type)
            let arg={tagType:"park"}
            ajaxPost('/tag/tagList', arg).then(function(res) {
              if(res.errorCode==200){
                // let keyname='data_'+type
                // _this[keyname]=res.data
                _this.tag_list_park=res.data

              }else{

              }
            }, function(res) {})
          },
            changeIsShow(id){
              let _this = this
              let arg={
                adminId:_this.adminId,
                parkId:id,
              }
              ajaxPost('/park/updateParkStatus', arg).then(function(res) {
                if(res.errorCode==200){
                  _this.$message({
                      message: "切换园区状态成功", //接口返回一个页面
                      type: 'success',
                      duration: 1500
                  });
                  _this.getTableLists()
                }else{
                  alert("切换失败")
                }


              }, function(res) {
              })
            },
            getParams(){
              this.lastPage=this.$route.query.from
            },
            toAdd(){
              this.$router.push("/park/add")
            },
            toEdit(id){
              this.$router.push({
                    name:'parkEdit',
                    params:{
                        parkId:id,
                   }
              })

            },
            toDetail(id){
              this.$router.push({
                    name:'parkDetail',
                    params:{
                        parkId:id,
                   }
              })

            },
            back() {
                this.$router.back()
            },
            getTableLists() {
                let _this = this
                this.isLoading = true
                ajaxPost('/park/getAllParkList', this.searchObj).then(function(res) {
                    _this.tableData = []
                    _this.isLoading = false
                    if (res.data && res.data.parkList) {
                        _this.total =parseInt(res.data.totalCount)
                        res.data.parkList.forEach(function(item, index) {
                            let buffer = {}
                            //id,名字，手机号，注册时间，渠道，身份，状态，地址
                            buffer.park_name = item.park_name
                            // buffer.address =item.region_province_string+item.region_city_string+ item.region_district_string+item.address_string
                            buffer.address = item.region_city_string+''+ item.address_string
                            buffer.park_contact_name = item.park_contact_name
                            buffer.park_contact_cellphone = item.park_contact_cellphone
                            buffer.park_intro = item.park_intro?item.park_intro.slice(0,50):''
                            buffer.store_tag_name =_this.getTagName(item.storeTag)
                            buffer.park_id = item.park_id
                            buffer.park_map_sequence=item.park_map_sequence
                            buffer.isShow=item.park_partner_state=='y'?true:false
                            _this.tableData.push(buffer)

                        })

                    }
                }, function(res) {
                    _this.isLoading = false
                })
            },
            handleSizeChange(size) { //分页：每页n条
                this.searchObj.num = size
                this.searchObj.page = 1
                this.getTableLists()
            },
            handleCurrentChange(page) { //分页：改变第n页
                this.searchObj.page = page
                this.getTableLists()
            },
            handleSelectionChange(val) { //表格多选框
                this.multipleSelection = val;
                console.log(this.multipleSelection)
            }
        },
        created() {
            console.log("执行created")
        	//获取session里存储的搜索条件，并赋值给当前表单
            this.getParams()

            let _this = this
            let sessionSearch=utils.getSearchObjFromSession()
            if(sessionSearch){
                console.log("session里存储了搜索条件")
                _this.searchObj=sessionSearch
                this.formObj.fuzzyQuery=_this.searchObj.fuzzyQuery
                this.formObj.userType=_this.searchObj.userType
                this.formObj.authResult=_this.searchObj.authResult
            }else if(_this.lastPage=='home'){
                _this.searchObj.authResult='p'
                this.formObj.authResult=_this.searchObj.authResult
            }else{
                console.log("session里没有搜索条件，也不是首页直接跳转")
            }
            console.log(_this.searchObj,'mounted里的搜索条件1111')
            this.getTableLists()

        },
        mounted(){
            console.log("执行mounted")
            this.get_tag_list_park()
        }
    }
</script>

<style scoped lang="scss">
    * {
        // outline: 1px solid blue;
    }

    .container {}


    .searchBox {
        padding: 0.25rem 0.25rem 0;

        .left {
            float: left;
        }

        .right {
            float: right;
        }
    }

    .searchBox:after {
        content: "";
        display: block;
        clear: both;
    }

    .tableBox {
        padding: 0.25rem;
    }
    .infiveline{
      width: 170px; border:1px dotted #eee;
      // height: 100px;

      overflow : hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 5;
      word-break:break-all;
      -webkit-box-orient: vertical;
    }
</style>



// WEBPACK FOOTER //
// src/pages/park/list.vue